import React, { useState } from "react"
import { Login } from "./Login"
import { Signup } from "./Signup"
import { ForgotPassword } from "./ForgotPassword"
import { AcceptInvite } from "./AcceptInvite"
import { useAuth } from "./AuthContext"

export function Auth() {
  const { isMagicLink } = useAuth()
  const [view, setView] = useState("login")

  if (isMagicLink) {
    return <AcceptInvite />
  }

  if (view === "forgot-password") {
    return <ForgotPassword onBack={() => setView("login")} />
  }

  if (view === "signup") {
    return <Signup onToggleMode={() => setView("login")} />
  }

  return <Login onToggleMode={() => setView("signup")} onForgotPassword={() => setView("forgot-password")} />
}
